var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-success"},[_c('Container',[_c('Card',{attrs:{"padding":"large"}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('Loader',{attrs:{"text":_vm.$t('LOADING')}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }